import { lsPut, safeAwait } from 'utils/request'

export const setArticleViewed = (articleId) => {
  return safeAwait(lsPut(`/articles/${articleId}/views`))
}
